import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Box, Typography, Grid, Pagination, Button } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import PermScanWifiIcon from '@mui/icons-material/PermScanWifi';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Divider from '@mui/material/Divider';
import LeadService from '../../core/services/leadsService';
import toast from 'react-hot-toast';
import CircularProgress from '@mui/material/CircularProgress';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useLocation } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import { debounce, throttle } from 'lodash';
import LinearProgress from '@mui/material/LinearProgress';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useParams, useNavigate, } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import ScrollAnimation from 'react-animate-on-scroll';
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
const useStyles = makeStyles((theme) => ({

    // chatViewOnlyMessage: {
    //     marginTop: '12px',
    //     [theme.breakpoints.down('md')]: {
    //         marginTop: '-13px',
    //         width: '582px',
    //     },
    // },


}));

const AdminChat = () => {
    const classes = useStyles()
        ; const theme = useTheme();
    const [selectedId, setSelectedId] = useState(null);
    const [chatAdminData, setChatAdminData] = useState([]);
    const [chatDetails, setChatDetails] = useState([]);
    const [loading, setLoading] = React.useState(true);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPages, setTotalPages] = React.useState(0);
    const [searchTerm, setSearchTerm] = React.useState('');
    const [nullLeadsId, setNullLeadsId] = React.useState();
    const [logOutModal, setLogOutModal] = React.useState(false);
    const location = useLocation();
    const { state } = location;
    const navigate = useNavigate();
    const abortControllerRef = useRef(null);

    const LeadsDetailId = state && state?.id;
    console.log(LeadsDetailId, 'lead own id');

    useEffect(() => {
        if (LeadsDetailId) {
            ChatAdminDetails(LeadsDetailId);
        }
    }, [LeadsDetailId]);

    const ChatAdmin = async (currentPage, searchTerm, LeadsDetailId, signal) => {
        try {
            if (searchTerm || currentPage) {
                setLoading(false)
            } else {
                setLoading(true)
            }
            const res = await LeadService.getChatAdmin(currentPage, searchTerm, LeadsDetailId, signal);
            if (res?.data?.success) {
                setChatAdminData(res?.data?.data?.data);
                setCurrentPage(res?.data?.data?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.data?.total || 1) / (res?.data?.data?.per_page || 1)));
                return;
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setLoading(false);
        }
    };

    // Throttled function to ensure a minimum delay of 2 seconds between calls
    const throttledGetChatData = useCallback(
        throttle((currentPage, searchTerm, LeadsDetailId, signal) => {
            ChatAdmin(currentPage, searchTerm, LeadsDetailId, signal);
        }, 2000), []
    );

    // Debounced function to delay the API call until the user stops typing
    const fetchChatData = useCallback(
        debounce((currentPage, searchTerm, LeadsDetailId) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetChatData(currentPage, searchTerm, LeadsDetailId, abortController.signal);
        }, 300), [throttledGetChatData]
    );

    useEffect(() => {
        fetchChatData(currentPage, searchTerm, LeadsDetailId);
    }, [currentPage, searchTerm, fetchChatData]);

    const handleBackClick = (LeadsDetailId) => {
        navigate(`/admin-leads-details/${LeadsDetailId}`);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    const ChatAdminDetails = async (id) => {
        try {
            const res = await LeadService.getChatAdminDetails(id);
            if (res?.data?.success) {
                setChatDetails(res?.data?.leadDetails);
                setSelectedId(id);
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message);
        }
    };

    const handleRefreshPage = async () => {
        setChatDetails([])
        await ChatAdmin('');
        setSearchTerm('');
        setSelectedId(null);
        location.state = { ...state, id: null };
    }

    return (
        <div>
            <div style={{ marginBottom: '15px' }}> {loading && <LinearProgress />}</div>
            {LeadsDetailId && (
                <>
                    <Box>

                        <Button onClick={() => handleBackClick(LeadsDetailId)}
                            sx={{ background: '#efefef', marginBottom: '12px', padding: '6px', '&:hover': { background: '#cecaca' }, }}>
                            <ArrowBackIosIcon style={{ color: '#8f7f7f', marginLeft: '6px' }} />
                        </Button>
                    </Box>
                </>
            )}
            <ScrollAnimation animateIn='fadeIn'>

                <div style={{ display: 'flex', flexDirection: 'column', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', }}>
                    {/* Header */}
                    {loading ? (
                        <CircularProgress style={{ marginTop: '250px', marginLeft: '700px' }} />
                    ) : (
                        <>
                            <ThemeProvider theme={theme}>
                                <GlobalStyles
                                    styles={{
                                        '::-webkit-scrollbar': {
                                            width: '4px', // Set the desired width for the scrollbar
                                        },
                                        '::-webkit-scrollbar-thumb': {
                                            backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                            borderRadius: '10px', // Set the border radius for a rounded effect
                                        },
                                    }}
                                />
                                <header
                                    style={{
                                        background: 'white',
                                        padding: '20px',
                                        borderRadius: "22px 22px 0px 0px"

                                    }}
                                >
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={4} md={3} lg={3}>
                                            <Paper
                                                component="form"
                                                sx={{
                                                    p: '9px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    background: '#F0F4F8',
                                                    borderRadius: '12px',
                                                    width: '100%'
                                                }}
                                            >
                                                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                                    <SearchIcon />
                                                </IconButton>
                                                <InputBase
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                    inputProps={{ 'aria-label': 'search google maps' }}
                                                    placeholder="Search by name"
                                                />
                                            </Paper>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={9} lg={9}>
                                            <Box className={classes.chatViewOnlyMessage} >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        padding: {
                                                            xs: '4px',
                                                            sm: '8px',
                                                            md: '15px'
                                                        },
                                                        gap: '4px',
                                                        background: '#FCF3E6',
                                                        borderRadius: {
                                                            xs: '4px',
                                                            sm: '8px',
                                                            md: '15px'
                                                        },
                                                    }}
                                                >
                                                    <PermScanWifiIcon sx={{
                                                        color: '#FF9700', width: {
                                                            xs: '15px',
                                                            sm: '20px',
                                                            md: '25px'
                                                        },
                                                        height: {
                                                            xs: '15px',
                                                            sm: '20px',
                                                            md: '25px'
                                                        }
                                                    }} />
                                                    <Typography sx={{
                                                        fontSize: {
                                                            xs: '10px',
                                                            sm: '16px',
                                                            md: '18px'
                                                        }, color: '#252F46'
                                                    }}>
                                                        You're currently in view-only mode. This means you can observe the conversation but cannot participate by sending
                                                        messages.
                                                    </Typography>

                                                </Box>

                                            </Box>
                                        </Grid>
                                    </Grid>




                                </header>

                                <Grid container spacing={{ xs: '0', sm: '2' }}>
                                    <Grid item xs={4} sm={4} md={3} lg={3}>
                                        <div style={{ display: 'grid' }}>
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    background: '#F0F4F8',
                                                    justifyContent: 'flex-end',
                                                    padding: '5px',
                                                    cursor: "pointer",
                                                }} onClick={handleRefreshPage}>
                                                <RefreshIcon style={{ fontSize: '28px' }} />
                                            </Box>
                                            <aside
                                                style={{
                                                    width: 'auto',
                                                    background: '#F0F4F8',
                                                    padding: '10px',
                                                    height: '80vh',
                                                    overflowY: 'auto',
                                                    overflowX: 'auto',
                                                    padding: '0px',
                                                    borderRadius: '0px'
                                                }}
                                            >

                                                <nav style={{ height: 'auto' }}>
                                                    {chatAdminData?.length > 0 ? (
                                                        chatAdminData?.map((chat, index) => {
                                                            const isLeadsDetailIdPassed = LeadsDetailId && chat?.lead?.id === LeadsDetailId;

                                                            const truncateMessage = (text) => {
                                                                if (text && text.length > 21) {
                                                                    return text.substring(0, 21) + '...';
                                                                }
                                                                return text;
                                                            };

                                                            const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
                                                                const date = new Date(dateString.replace(/-/g, '/'));
                                                                // Convert to UTC and then apply offset
                                                                const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
                                                                utcDate.setHours(utcDate.getHours() + offsetInHours);
                                                                return utcDate;
                                                            };

                                                            const getUserOffset = () => {
                                                                const offset = localStorage.getItem('userOffset');
                                                                return offset ? parseFloat(offset) : 0;
                                                            };

                                                            const formatTime = (date) => {
                                                                const options = { hour: '2-digit', minute: '2-digit', hour12: true };
                                                                return date.toLocaleTimeString(undefined, options).replace(',', '');
                                                            };

                                                            const userOffset = getUserOffset();
                                                            const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(chat?.lead?.chat?.timestamp, userOffset);

                                                            const formattedTime = adjustedDate ? formatTime(adjustedDate) : "No time available";


                                                            return (
                                                                <div key={index.id}>
                                                                    <Box
                                                                        onClick={() => { ChatAdminDetails(chat?.lead?.id) }}
                                                                        style={{
                                                                            padding: '10px 5px',
                                                                            cursor: 'pointer',
                                                                            borderRadius: '0px',
                                                                            // width: '383px',
                                                                            // background: isLeadsDetailIdPassed ? 'white' : chat.lead.id === selectedId ? 'white' : '',
                                                                            background: selectedId ? (chat.lead.id === selectedId ? 'white' : '') : (isLeadsDetailIdPassed ? 'white' : ''),
                                                                        }}
                                                                    >
                                                                        {loading && <CircularProgress sx={{ color: 'white' }} />}
                                                                        <Box
                                                                            style={{
                                                                                display: 'flex',
                                                                                gap: '13px',
                                                                                height: 'auto',
                                                                            }}
                                                                        >
                                                                            <Grid container>
                                                                                <Grid item xs={12} sm={2} md={2}>
                                                                                    <Box>
                                                                                        <Avatar
                                                                                            src={`https://iconnctapp.com/${chat?.lead?.customer_profile_image}`}
                                                                                            sx={{
                                                                                                width: {
                                                                                                    xs: '20px',
                                                                                                    sm: '30px',
                                                                                                    md: '30px'
                                                                                                }, height: {
                                                                                                    xs: '20px',
                                                                                                    sm: '30px',
                                                                                                    md: '30px'
                                                                                                },
                                                                                            }}
                                                                                        />
                                                                                    </Box>
                                                                                </Grid>
                                                                                <Grid item xs={12} sm={10} md={8}>
                                                                                    <Box sx={{ display: 'flex' }}>
                                                                                        <Box>
                                                                                            <Typography
                                                                                                sx={{
                                                                                                    fontSize: { xs: '8px', sm: '12px', md: '14px' },
                                                                                                    fontWeight: '600',
                                                                                                }}
                                                                                            >
                                                                                                {chat?.lead?.first_name}{' '}
                                                                                                {chat?.lead?.last_name}{', '}
                                                                                                {chat?.assignby?.name} {' '}
                                                                                                {chat?.assignby?.last_name} {','}
                                                                                                {chat?.assignto?.name} {' '}
                                                                                                {chat?.assignto?.last_name} {' '}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                    <Box>
                                                                                        <Typography
                                                                                            sx={{
                                                                                                fontSize: { xs: '8px', sm: '12px', md: '14px' },
                                                                                                fontWeight: '400',
                                                                                                color: '#334E68',
                                                                                            }}
                                                                                        >
                                                                                            {truncateMessage(chat?.lead?.chat?.message)}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Grid>
                                                                                <Grid item xs={12} sm={12} md={2}>
                                                                                    <Typography
                                                                                        sx={{
                                                                                            fontSize: {
                                                                                                xs: '8px',
                                                                                                sm: '12px',
                                                                                                md: '14px'
                                                                                            },
                                                                                            fontWeight: '400',
                                                                                            color: '#627D98',
                                                                                        }}
                                                                                    >
                                                                                        {formattedTime}
                                                                                    </Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Box>
                                                                    </Box>
                                                                </div>
                                                            );
                                                        })
                                                    ) : (
                                                        <Typography
                                                            style={{
                                                                fontSize: '16px',
                                                                fontWeight: '400',
                                                                color: '#627D98',
                                                                textAlign: 'center',
                                                                marginTop: '30px',
                                                                width: '383px',
                                                            }}
                                                        >
                                                            No data found!
                                                        </Typography>
                                                    )}

                                                </nav>
                                                <Box style={{ marginTop: '10px' }}>
                                                    {chatAdminData && chatAdminData?.length > 0 ? (
                                                        <Pagination
                                                            count={totalPages}
                                                            color="primary"
                                                            page={currentPage}
                                                            onChange={(event, value) => setCurrentPage(value)}
                                                            sx={{
                                                                fontSize: { xs: "0.75rem", sm: "1rem", md: '16px' },
                                                                "& .MuiPaginationItem-root": {
                                                                    fontSize: { xs: "10px", sm: "12px", md: '16px' },
                                                                    height: {
                                                                        xs: '15px',
                                                                        sm: '26px',
                                                                        md: '32px',
                                                                    },
                                                                    minWidth: {
                                                                        xs: '15px',
                                                                        sm: '26px',
                                                                        md: '32px',
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    ) : null}
                                                </Box>
                                            </aside>
                                        </div>
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={9} lg={9} sx={{ backgroundColor: '#fff' }}>
                                        <Box sx={{
                                            // flex: 1,
                                            padding: {
                                                xs: '4px',
                                                sm: '8px',
                                                md: '10px'
                                            },
                                            background: 'white',
                                            height: '86vh',
                                            overflowY: 'auto',
                                            width: '100%',
                                            overflowX: 'hidden',
                                            borderRadius: '0px 0px 22px 0px',
                                        }}>

                                            {chatDetails?.map((chat, index) => {
                                                const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
                                                    const date = new Date(dateString.replace(/-/g, '/'));
                                                    // Convert to UTC and then apply offset
                                                    const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
                                                    utcDate.setHours(utcDate.getHours() + offsetInHours);
                                                    return utcDate;
                                                };


                                                const getUserOffset = () => {
                                                    const offset = localStorage.getItem('userOffset');
                                                    return offset ? parseFloat(offset) : 0;
                                                };

                                                const formatDateTime = (date) => {
                                                    const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
                                                    return date.toLocaleDateString(undefined, options).replace(',', '');
                                                };

                                                const userOffset = getUserOffset();
                                                const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(chat?.timestamp, userOffset);

                                                const formattedDate = adjustedDate ? formatDateTime(adjustedDate) : "No date available";
                                                return (
                                                    <Box key={index}>
                                                        <Box style={{ marginTop: '10px' }}>
                                                            <Divider />
                                                        </Box>
                                                        <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                                            <Typography sx={{
                                                                fontSize: {
                                                                    xs: '8px',
                                                                    sm: '10px',
                                                                    md: '14px'
                                                                }, fontFamily: 'inherit'
                                                            }}>
                                                                &nbsp;{formattedDate} {' '}
                                                            </Typography>
                                                        </Box>

                                                        <Box>
                                                            <Box
                                                                sx={{
                                                                    display: {
                                                                        xs: 'block',
                                                                        sm: 'flex',
                                                                        md: 'flex'
                                                                    },
                                                                    gap: '1px',
                                                                }}
                                                            >

                                                                <Box style={{ marginTop: '10px' }}>
                                                                    <Avatar src={`https://iconnctapp.com/${chat?.sender_profileImage}`}
                                                                        sx={{
                                                                            width: {
                                                                                xs: '20px',
                                                                                sm: '30px',
                                                                                md: '50px'
                                                                            },
                                                                            height: {
                                                                                xs: '20px',
                                                                                sm: '30px',
                                                                                md: '50px'
                                                                            },
                                                                        }}
                                                                    />

                                                                </Box>
                                                                {chat?.message && (
                                                                    <Box
                                                                        sx={{
                                                                            marginTop: {
                                                                                xs: '2px',
                                                                                sm: '6px',
                                                                                md: '8px'
                                                                            },
                                                                            background: 'linear-gradient(#26c7f3, #316ec1)',
                                                                            borderRadius: {
                                                                                xs: '4px',
                                                                                sm: '10px',
                                                                                md: '14px'
                                                                            },
                                                                            width: 'auto',
                                                                            overflow: 'hidden',
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                color: '#F0F4F8',
                                                                                padding: {
                                                                                    xs: '2px 4px 0px 4px',
                                                                                    sm: '5px 4px 0px 4px',
                                                                                    md: '8px'
                                                                                },
                                                                                fontSize: {
                                                                                    xs: '9px',
                                                                                    sm: '12px',
                                                                                    md: '15px'
                                                                                },
                                                                                whiteSpace: 'pre-wrap',
                                                                                wordWrap: 'break-word',
                                                                                overflowWrap: 'break-word',
                                                                                fontWeight: 'bold',
                                                                            }}
                                                                        >
                                                                            <FiberManualRecordIcon fontSize="6px" />{chat?.name}
                                                                        </Typography>
                                                                        <Typography
                                                                            sx={{
                                                                                color: '#F0F4F8',
                                                                                padding: {
                                                                                    xs: '2px 4px 4px 4px',
                                                                                    sm: '5px 4px 4px 4px',
                                                                                    md: '8px'
                                                                                },
                                                                                fontSize: {
                                                                                    xs: '9px',
                                                                                    sm: '12px',
                                                                                    md: '15px'
                                                                                },
                                                                                whiteSpace: 'pre-wrap',
                                                                                wordWrap: 'break-word',
                                                                                overflowWrap: 'break-word',
                                                                            }}
                                                                        >
                                                                            {' '}{chat?.message}
                                                                        </Typography>
                                                                    </Box>
                                                                )}

                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                )
                                            })}
                                        </Box>
                                    </Grid>
                                </Grid>


                                {/* Main Body */}

                            </ThemeProvider>
                        </>

                    )}
                </div>
            </ScrollAnimation>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
        </div>

    );
};
export default AdminChat;